import React, { lazy, Suspense } from "react";
import Spacer from "../Spacer/Spacer";
import { useAleloContext } from "src/context/aleloContext";
import { DrawerLoginInner } from "./Header.styles";
import { LoginDrawerModel } from "./Header.types";
import { RangoIcon, RangoTooltip } from "@rango/core";

const LazyRangoDrawer = lazy(() =>
	import("@rango/core").then((module) => ({
		default: module.RangoDrawer,
	}))
);

const LazyRangoHeading = lazy(() =>
	import("@rango/core").then((module) => ({
		default: module.RangoHeading,
	}))
);

const LazyRangoLinkIcon = lazy(() =>
	import("@rango/core").then((module) => ({
		default: module.RangoLinkIcon,
	}))
);

export default function DrawerLogin({
	loginNewTab,
	loginLabel,
	portalMeuAleloLabel,
	portalMeuAlelo,
	portalMeuEcLabel,
	portalMeuEc,
	aleloTudoLabel,
	aleloTudo,
	aleloPodLabel,
	aleloPod,
	aleloGestaoDeVtLabel,
	aleloGestaoDeVt,
	outrosBeneficiosLabel,
	outrosBeneficios,
	veloeGoLabel,
	veloeGo,
}: LoginDrawerModel) {
	const { currentModal, setCurrentModal } = useAleloContext();

	function handleClose() {
		setCurrentModal({ modal: "", step: "" });
	}
	return (
		<Suspense
			fallback={
				<Spacer
					mobile={"0"}
					tablet={"0"}
					desktop={"0"}
					isInEditor={false}
					cqPath={""}
				/>
			}
		>
			<LazyRangoDrawer
				closeOnOverlayClick
				id={"loginDrawer"}
				open={currentModal?.modal === "loginDrawer"}
				className="drawer__login"
				size="sm"
				type="flow"
				style={{ zIndex: 9999 }}
				navbar={{
					heading: { children: loginLabel || "Login", tag: "h2" },					
					onClose: () => {
						handleClose();
					},
				}}
				onClose={() => {
					handleClose();
				}}
			>
				<DrawerLoginInner>
					<div className="login__group">
						<LazyRangoHeading
							size="2xs"
							tag="h3"
							style={{ color: "#191919", marginBottom: "8px" }}
						>
							Meu Alelo
						</LazyRangoHeading>
						<LazyRangoLinkIcon
							href={portalMeuAlelo || "#"}
							target={loginNewTab ? "_blank" : "_self"}
							{...{
								title: "Portal Meu Alelo",
								element_parent: "Login Drawer",
								element_type: "link",
								destination: portalMeuAlelo,
							}}
						>
							{portalMeuAleloLabel || "Portal Meu Alelo"}								
						</LazyRangoLinkIcon>
					</div>
					<div className="login__group">
						<LazyRangoHeading
							size="2xs"
							tag="h3"
							style={{ color: "#191919", marginBottom: "8px" }}
						>
							Para estabelecimento
						</LazyRangoHeading>
						<LazyRangoLinkIcon
							href={portalMeuEc || "#"}
							target={loginNewTab ? "_blank" : "_self"}
							{...{
								title: "Portal Meu EC",
								element_parent: "Login Drawer",
								element_type: "link",
								destination: portalMeuEc,
							}}
						>
							{portalMeuEcLabel || "Portal Meu EC"}								
						</LazyRangoLinkIcon>
					</div>
					<div className="login__group">
						<LazyRangoHeading
							size="2xs"
							tag="h3"
							style={{ color: "#191919", marginBottom: "8px" }}
						>
							Para RH
						</LazyRangoHeading>
						<div className="relative__div">
							<LazyRangoLinkIcon
								href={aleloTudo || "#"}
								target={loginNewTab ? "_blank" : "_self"}
								{...{
									title: "Alelo Tudo",
									element_parent: "Login Drawer",
									element_type: "link",
									destination: aleloTudo,
								}}
							>
								{aleloTudoLabel || "Alelo Alimentação, Alelo Refeição e Alelo Tudo"}									
							</LazyRangoLinkIcon>
							<RangoTooltip
								position={"top"}
								label={
									"Alelo Alimentação, Alelo Refeição, Alelo Multibenefícios, Alelo Natal e Alelo Cultura"
								}
							>
								<RangoIcon
									icon={"InformationLine"}
									size="SM"
									style={{
										color: "#015850",
										display: "inline-block",
										position: "relative",
										top: "5px",
										right: "-10px",
									}}
								/>
							</RangoTooltip>
						</div>
						<LazyRangoLinkIcon
							href={aleloPod || "#"}
							target={loginNewTab ? "_blank" : "_self"}
							{...{
								title: "Alelo Pod",
								element_parent: "Login Drawer",
								element_type: "link",
								destination: aleloPod,
							}}
						>
							{aleloPodLabel || "Alelo Pod"}								
						</LazyRangoLinkIcon>
						<LazyRangoLinkIcon
							href={aleloGestaoDeVt || "#"}
							target={loginNewTab ? "_blank" : "_self"}
							{...{
								title: "Alelo Gestão de VT",
								element_parent: "Login Drawer",
								element_type: "link",
								destination: aleloGestaoDeVt,
							}}
						>
							{aleloGestaoDeVtLabel || "Alelo Gestão de VT"}								
						</LazyRangoLinkIcon>
						<LazyRangoLinkIcon
							href={outrosBeneficios || "#"}
							target={loginNewTab ? "_blank" : "_self"}
							{...{
								title: "Outros Benefícios",
								element_parent: "Login Drawer",
								element_type: "link",
								destination: outrosBeneficios,
							}}
						>
							{outrosBeneficiosLabel || "Alelo Pré-Pagos"}								
						</LazyRangoLinkIcon>
						<LazyRangoLinkIcon
							href={veloeGo || "#"}
							target={loginNewTab ? "_blank" : "_self"}
							{...{
								title: "Veloe Go",
								element_parent: "Login Drawer",
								element_type: "link",
								destination: veloeGo,
							}}
						>
							{veloeGoLabel || "Veloe Go"}								
						</LazyRangoLinkIcon>
					</div>
				</DrawerLoginInner>
			</LazyRangoDrawer>
		</Suspense>
	);
}
